import { ReactNode } from 'react';

export interface GridLayoutContainerProps {
  children: ReactNode;
  spacing?: number;
}

const GridLayoutContainer: React.FC<GridLayoutContainerProps> = ({
  children,
  spacing = 2,
}) => {
  const spacingPixels = `${spacing * 8}px`;

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        rowGap: spacingPixels,
        columnGap: spacingPixels,
      }}
    >
      {children}
    </div>
  );
};

export default GridLayoutContainer;
